export default __webpack_public_path__ + "static/media/shopping-basket.8f6f0ce4.svg";